import { render, staticRenderFns } from "./document.vue?vue&type=template&id=adbf898c&scoped=true"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"
import style0 from "./document.vue?vue&type=style&index=0&id=adbf898c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbf898c",
  null
  
)

export default component.exports